<template>
    <div class="mt-10 mb-4">
        <h4>
            <slot></slot>
        </h4>
    </div>
</template>

<script>
export default {
    name: "SectionLabel"
}
</script>

<style scoped>
div {
    @apply flex justify-center;
}

h4 {
    @apply w-content max-w-full flex flex-row items-center relative pl-4 ml-2 lg:ml-0;
    @apply text-main-color;
    font-size: 20px;
    font-weight: 500;
    line-height: 40px;
    letter-spacing: 0.16em;
}

h4:before {
    @apply absolute bottom-0;
    content: '';
    width: 3px;
    height: 20px;
    left: 0;
    top: 11px;
    background-color: #d11a30;
}
</style>
